import {Presenter} from '../../../../../../Support/with_presenter';
import {WorkoutsService} from '../../../../../../Network/WorkoutsService';
import {endOfWeek, startOfWeek} from 'date-fns';
import {loadingResponse, NetworkResult} from '../../../../../../Network/NetworkResult';
import {CrewWeekReport} from '../../../../../../Models/CrewWeekReport';

export class ThisWeekPresenter implements Presenter {
    public weekReport: NetworkResult<CrewWeekReport> = loadingResponse();

    constructor(private crewId: number, private workoutService: WorkoutsService) {}

    public async mount(): Promise<void> {
        const referenceDate = new Date();

        this.weekReport = await this.workoutService.thisWeekOfCrew(
            this.crewId,
            startOfWeek(referenceDate),
            endOfWeek(referenceDate),
        );
    }

    public unmount(): void {
        /* Noop */
    }
}
